import BaseAPI from '../utility/fetch-wrapper';

class FormService {
    static SubmitForm = async payload => {
        const data = await BaseAPI.postRequest(`orders`, payload);

        return data;
    };

    static SendEmail = async payload => {
        const data = await BaseAPI.postRequest(`sendgrid/sendemail`, payload);
        return data;
    };

    static SendOrderConfirmationEmail = async (draft, emailRecipients, orderNumber, firstNameCaseManager) => {
        const payload =
        {
            emailRecipients: emailRecipients,
            subjectLine: "Glucroft Order Confirmation",
            emailBody: draft
                ? `Dear ${firstNameCaseManager}, \n\nYour order (${orderNumber}) has been successfully saved as a draft. \n\nNavigate to the orders page to view and continue working on your order.`
                : `Dear ${firstNameCaseManager}, \n\nWe have received your submission (${orderNumber}) thank you! \n\nWe will turn around your order as quickly as possible. Please Note: Although we can investigate policy coverage for USAA, we are now unable to guarantee the result is consistent with the date of loss.`
        };
        const data = await BaseAPI.postRequest(`sendgrid/sendemail`, payload);
        return data;
    };
}


export default FormService;